import { useMutation, UseMutationConfig } from '@libs/use';
import { EmbeddedPutOptionRequestBody } from '@libs/api-reference';

import * as API from '../../requests';

type UseCreateEmbeddedPutOptionRequestOptions = {
  onReject?: UseMutationConfig<object>['onReject'];
  onSuccess?: UseMutationConfig<object>['onSuccess'];
};

export default function useCreateEmbeddedPutOptionRequestQuery({
  onReject,
  onSuccess,
}: UseCreateEmbeddedPutOptionRequestOptions = {}) {
  const {
    execute: createEmbeddedPutOptionRequest,
    isPending: isLoadingCreateEmbeddedPutOptionRequest,
    ...query
  } = useMutation(
    ({ formModel }: { formModel: EmbeddedPutOptionRequestBody }) =>
      API.createEmbeddedPutOptionRequest(formModel),
    {
      onSuccess,
      onReject,
    }
  );

  return {
    createEmbeddedPutOptionRequest,
    isLoadingCreateEmbeddedPutOptionRequest,
    ...query,
  };
}
